export const REFERRAL_OP_ASSET_TYPE_ID = '00000000-0000-4000-8000-000000002104';
//# sourceMappingURL=member-referral.js.map